import Vue from 'vue'
import App from '@/App'
import "./init.js";
import router from '@/router'                 // api: https://github.com/vuejs/vue-router
import store from '@/store'                   // api: https://github.com/vuejs/vuex
import VueCookie from 'vue-cookie'            // api: https://github.com/alfhen/vue-cookie
import '@/element-ui'                         // api: https://github.com/ElemeFE/element
// import '@/icons'                              // api: http://www.iconfont.cn/
// import '@/assets/scss/index.scss'
import 'element-ui/lib/theme-chalk/index.css';
// import Vant from 'vant';
import 'vant/lib/index.css';

import '@/vant/vant.js'
import '@/utils/appback.js'
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import { isAuth } from '@/utils'
import cloneDeep from 'lodash/cloneDeep'

// import '@/assets/js/liveplayer-lib.min.js'
import '@/assets/js/iconfont.js'
import '@/assets/js/iconfont1.js'
import '@/assets/js/iconfont2.js'
import '@/assets/js/iconfont3.js'

// 富文本回显
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import longpress from '@/utils/longpress';

window.SITE_CONFIG = {};
// window.SITE_CONFIG['baseUrl'] = 'http://114.132.242.20:8080/renren-fast';
window.SITE_CONFIG['baseUrl'] = 'https://www.gzdiyun.cn/diyun-api';

// window.SITE_CONFIG['baseUrl'] = 'http://localhost:8080/renren-fast';
// window.SITE_CONFIG['baseUrl'] = 'http://192.168.195.18:8080/renren-fast';

Vue.prototype.$http = httpRequest // ajax请求方法

Vue.directive('longpress', longpress);
Vue.use(VueCookie)
Vue.use(VueQuillEditor)
// Vue.use(Vant)
Vue.config.productionTip = false


// 挂载全局
Vue.prototype.$http = httpRequest // ajax请求方法
// Vue.prototype.isAuth = isAuth     // 权限方法

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)

new Vue({
  store,
  router,
  render: h => h(App),
  created () {
    this.$store.dispatch('brand/loadBrand', this.$http)
  }
}).$mount('#app')
